module.exports = __webpack_public_path__ + "img/install-ios-02.06b974d8.jpg";